import React from 'react';

import Message from '../common/message/Message';

export const ProgHead = props => <Message as="h4" className="prog__txt-head" {...props} />;
